import { render, staticRenderFns } from "./EnacCustomAtplAssessmentEditStruct.vue?vue&type=template&id=5dd0423c"
import script from "./EnacCustomAtplAssessmentEditStruct.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplAssessmentEditStruct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports